<template>
    <div class="col-lg-2 col-sm-6 col-6">
        <vue-content-loading :height="5" :width="5" >
            <rect x="0" y="0" rx="0" ry="0" width="50" height="50" />
        </vue-content-loading>
    </div>
</template>

<script>
    import VueContentLoading from 'vue-content-loading';
    export default {
        name: "spinner-home",
        components: {
            VueContentLoading,
        },
    }
</script>

<style scoped>
div{
    padding: 1px;
}
</style>
